<template>
  <v-card id="chat-card" class="pa-4">
    <div class="d-flex align-center">
      <strong>Chat de Suporte</strong>
      <v-spacer></v-spacer>
      <v-menu
        v-if="$vuetify.breakpoint.smAndUp"
        v-model="expandMenu"
        offset-y
        left
      >
        <template #activator="{ on, attrs }">
          <v-btn icon class="mx-2" v-bind="attrs" v-on="on" text>
            <v-icon>mdi-dock-window</v-icon>
          </v-btn>
        </template>
        <div class="d-flex align-center pa-4" style="background: #ffffff">
          <v-list-item
            link
            class="d-block text-center pa-2 expand-item"
            @click="toLeft"
          >
            <v-icon> mdi-format-horizontal-align-left </v-icon>
            <br />
            Esquerda
          </v-list-item>

          <v-list-item
            link
            class="d-block text-center pa-2 expand-item"
            @click="toRight"
          >
            <v-icon>mdi-format-horizontal-align-right</v-icon>
            <br />
            Direita
          </v-list-item>
        </div>
      </v-menu>

      <v-btn
        x-small
        fab
        elevation="0"
        color="secondary"
        @click="$emit('close')"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-divider class="ma-4 mt-1"></v-divider>

    <v-window v-model="step">
      <v-window-item :value="1">
        <Senders @select="goToChat" :key="step" />
      </v-window-item>

      <v-window-item :value="2">
        <Messages :key="chat.id" :chat="chat" @back="step--" />
      </v-window-item>
    </v-window>
  </v-card>
</template>

<style scoped>
#chat-card {
  position: fixed;
  z-index: 10 !important;
  margin: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 6.25px !important;
  min-width: 405px;
  max-width: 505px;
  bottom: 0;
  right: 0;
}
</style>

<script>
import anime from 'animejs'
import Senders from './chatSenders.vue'
import Messages from './chatMessages.vue'

export default {
  name: 'ChatComponent',

  created() {
    const institution = JSON.parse(localStorage.getItem('institution'))

    if (institution.userType != 0) this.step = 2
  },

  components: {
    Senders,
    Messages,
  },

  data() {
    return {
      chat: {},
      expandMenu: false,
      step: 1,
    }
  },

  methods: {
    goToChat(item) {
      this.chat = item
      this.step++
    },

    toLeft() {
      anime({
        targets: '#chat-card',
        translateX: -(window.innerWidth - 541 - 30),
        width: '541px',
        duration: 3000,
        easing: 'easeOutExpo',
      })
    },

    toRight() {
      anime({
        targets: '#chat-card',
        translateX: 0,
        width: '541px',
        duration: 3000,
        easing: 'easeOutExpo',
      })
    },

    expand() {
      anime({
        targets: '#chat-card',
        maxWidth: '99%',
        width: '99%',
        translateX: 0,
        duration: 3000,
        easing: 'easeOutExpo',
      })
    },
  },
}
</script>
